import React from 'react';
import './SideBar.scss';

const SidebarTitle = (props) => {
    return (<h3 className="sidebar-title">
        {props.icon ? <span className="sidebar-title-icon">{props.icon}</span> : ''}
        {props.title}
    </h3>)
};

export default SidebarTitle;
